import { render, staticRenderFns } from "./findPassWord.vue?vue&type=template&id=1a606689&scoped=true&"
import script from "./findPassWord.vue?vue&type=script&lang=js&"
export * from "./findPassWord.vue?vue&type=script&lang=js&"
import style0 from "./findPassWord.vue?vue&type=style&index=0&id=1a606689&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a606689",
  null
  
)

export default component.exports